import angular from 'angular';
import html2canvas from 'html2canvas';
import { ScenarioTemplatesDependenciesComponent } from 'src/app/care/scenarios/social-networks/whatsapp/scenario-templates-dependencies/scenario-templates-dependencies.component';
import { utf8ToBase64 } from '../../../utils/alcmeon-utils';

QuickRepliesDetailsController.$inject = [
  '$scope',
  'TopToolbarFactory',
  '$mdDialog',
  'QuickRepliesFactory',
  'site',
  'allScenarios',
  'scenario',
  '$state',
  'ClicksMetricHelperFactory',
  'MediasFactory',
  'AlertingFactory',
  'StrategiesFactory',
  'scenarioFlavor',
  'ConfirmationFactory',
  'ScrollFactory',
  'redirectedFromOptins',
  '$stateParams',
  'AngularAlcmeonContextService',
  'AngularMatDialog',
  'AngularSpinnerService'
];
export function QuickRepliesDetailsController(
  $scope,
  TopToolbarFactory,
  $mdDialog,
  QuickRepliesFactory,
  site,
  allScenarios,
  scenario,
  $state,
  ClicksMetricHelperFactory,
  MediasFactory,
  AlertingFactory,
  StrategiesFactory,
  scenarioFlavor,
  ConfirmationFactory,
  ScrollFactory,
  redirectedFromOptins,
  $stateParams,
  AngularAlcmeonContextService,
  AngularMatDialog,
  AngularSpinnerService
) {
  AngularSpinnerService.hideSpinner();
  $scope.allScenarios = allScenarios;
  if ($stateParams.boxId) {
    const filteredScenarios = $scope.allScenarios.filter(s => $stateParams.boxId in s.graphs.all_time.elements);
    if (filteredScenarios.length) {
      scenarioFlavor = filteredScenarios[0].flavor;
    }
  }

  $scope.exportMetricData = exportMetricData;
  $scope.scenariosWithCurrentFlavor = allScenarios.filter(s => s.flavor === scenarioFlavor);
  init();

  function editName() {
    $mdDialog.show({
      controller: 'QuickRepliesNameEditionController',
      template: require('./quick-replies.nameEdition.html'),
      clickOutsideToClose: true,
      locals: {
        'name': $scope.scenario.common.name
      }
    }).then(result => {
      $scope.scenario.common.name = result;
      registerChange();
    });
  }

  function saveScenario() {
    $scope.isSaving = true;
    QuickRepliesFactory.updateScenario(site.company.id, site.id, $scope.scenario, scenarioFlavor)
      .then(function (response) {
        $scope.data.scenarioHasChanged = false;
        $scope.savedScenario = response.data;
        AlertingFactory.success('parameters/quick_replies/details/update_success');
      }, function (response) {

        const { error_code } = response.data && response.data.error;
        if (error_code === 1) {
          AlertingFactory.error('parameters/quick_replies/internal_errors/1');
        }
        else if (error_code === 3) {
          AlertingFactory.error('parameters/quick_replies/internal_errors/3');
        }
        else if (error_code === 2) {
          // In this case the scenario should have stayed activated but it was deactivated instead.
          AlertingFactory.error('parameters/quick_replies/internal_errors/2');
          $scope.savedScenario = response.data.error.reason.scenario;
          $scope.scenario.common.is_active = response.data.error.reason.scenario.common.is_active;
        }
        else if (error_code === 4) {
          AlertingFactory.error('parameters/quick_replies/internal_errors/4');
        }
        else if (error_code === 5) {
          AlertingFactory.error(response.data.error.reason.key);
        }
        else if (error_code === 6) {
          AlertingFactory.error('parameters/quick_replies/internal_errors/6');
        }
        else if (response.data.error?.reason === 'unable-to-deactivate-because-of-active-shortcuts-in-templates') {
          checkAgentShortcutsDependencies();
        }
        else {
          AlertingFactory.alertHTTPError(response);
        }
      })
      .finally(() => $scope.isSaving = false);
  }

  async function checkAgentShortcutsDependencies() {
    try {
      const { data } = await QuickRepliesFactory.getAgentShortcutDependencies($scope.companyId, site.id, $scope.scenario.common.id);

      Object.keys(data).forEach(key => {
        data[key].forEach(dependency => { dependency.scenarioId = key; })
      });

      const dependencies = Object.values(data).flatten();

      if (!dependencies.length) {
        return;
      }

      AngularMatDialog.open(ScenarioTemplatesDependenciesComponent, {
        data: {
          dependencies,
          siteId: site.id
        },
      });

    } catch (error) {
      AlertingFactory.alertHTTPError(error);
    }
  }


  function registerChange() {
    if (angular.equals($scope.scenario, $scope.savedScenario)) {
      $scope.data.scenarioHasChanged = false;
    }
    else {
      $scope.data.scenarioHasChanged = true;
    }
  }

  function confirmAndSave() {
    let scenario = $scope.scenario;
    let savedScenario = $scope.savedScenario;
    let enabledScenarios = $scope.scenariosWithCurrentFlavor.filter(scen => scen.is_active === 1
      && scen.site_id === site.id
      && scen.id !== scenario.common.id);
    let confirmText = '';

    if (scenarioFlavor === 'quick-replies') {
      if (!savedScenario.common.is_active && scenario.common.is_active && enabledScenarios.length === 0) {
        confirmText = 'parameters/quick_replies/details/confirm_activating';
      }
      else if (!savedScenario.common.is_active && scenario.common.is_active && enabledScenarios.length > 0) {
        confirmText = 'parameters/quick_replies/details/confirm_activating_and_deactivating_other';
      }
      else if (savedScenario.common.is_active && !scenario.common.is_active) {
        confirmText = 'parameters/quick_replies/details/confirm_deactivating';
      }
    }

    if (confirmText) {
      ConfirmationFactory.materialConfirmDialog(confirmText).then(() => saveScenario());
    } else {
      saveScenario();
    }
  }

  function updateSaveButton() {
    TopToolbarFactory.updateButtonText($scope.isSaving ? 'saving' : 'save', $scope);
    TopToolbarFactory.updateButtonDisable(!$scope.data.scenarioHasChanged || $scope.isSaving, $scope);
  }

  function switchUpated(booleanValue) {
    $scope.scenario.common.is_active = booleanValue ? 1 : 0;
    registerChange();
  }

  function exportMetricData() {
    QuickRepliesFactory.createBoxClicksExports(
      site.company.id,
      site.id,
      scenario.common.id,
      $scope.clicksMetric.metricData
    ).then(response => {
      MediasFactory.downloadFile(response.data.url);
    }, AlertingFactory.httpErrorHandler());
  }

  async function exportScenario() {

    const canvas = await html2canvas(document.querySelector("joint-diagram"), {
      useCORS: true
    })
    var dataURL = canvas.toDataURL('image/png');

    QuickRepliesFactory.exportScenario(
      site.company.id,
      site.id,
      $scope.scenario.common.id,
    ).then(response => {
      const { content, content_type, content_filename } = response.data;

      const byteCharacters = atob(content);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset++) {
        const byteArray = new Uint8Array(1);
        byteArray[0] = byteCharacters.charCodeAt(offset);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: content_type });

      const reader = new FileReader();
      reader.onloadend = () => {
        try {
          const jsonContent = JSON.parse(reader.result);
          jsonContent.preview = dataURL;
          const updatedContent = utf8ToBase64(JSON.stringify(jsonContent));
          MediasFactory.downloadBinaryBase64(updatedContent, content_type, content_filename);
        } catch (error) {
          // In case of issue, do not include the preview.
          MediasFactory.downloadBinaryBase64(content, content_type, content_filename);
        }
      };
      reader.readAsText(blob);

    }, AlertingFactory.httpErrorHandler());
  }

  function init() {
    $scope.quickRepliesEnabled = site.quick_replies_enabled;
    if (!site.quick_replies_enabled) {
      return;
    }

    TopToolbarFactory.setFirstLevelNavTranslation('sidenav/automation/chatbots', $scope, () => $state.go('auth.alcmeon.fuse.parameters.all-accounts.' + scenarioFlavor));
    TopToolbarFactory.setExtraClass(scenarioFlavor === 'campaign-scenarios' ? 'marketing' : '', $scope);
    TopToolbarFactory.setButton('save', confirmAndSave, $scope);
    if (AngularAlcmeonContextService.isAlcmeonUser()) {
      TopToolbarFactory.setSecondaryButton('export', exportScenario, $scope);
    }
    TopToolbarFactory.setTitleIconButton('edit', editName, $scope);
    const goBackTranslationKey = 'parameters/automate/clusters/actions/back';
    const uisref = redirectedFromOptins ? 'auth.alcmeon.fuse.optins' : 'auth.alcmeon.fuse.parameters.all-accounts.' + scenarioFlavor;
    TopToolbarFactory.setGoBackLink(goBackTranslationKey, uisref, $scope);
    const switchTranslationKey = 'parameters/quick_replies/details/activated_scenario_short';
    const switchValue = scenario.common.is_active === 1;
    TopToolbarFactory.setSwitch(switchTranslationKey, switchValue, switchUpated, $scope);
    $scope.$watch('isSaving', updateSaveButton);
    $scope.$watch('data.scenarioHasChanged', updateSaveButton);
    $scope.$watch('scenario.common.name', newName => TopToolbarFactory.setTitle(newName, $scope));
    // Let's scroll to the top because the joint-diagram directive will get rid of the scroll bar
    ScrollFactory.scrollMainContainerToTop();

    $scope.companyId = site.company.id;
    $scope.site = site;

    $scope.translationData = {};

    $scope.scenario = angular.copy(scenario);
    $scope.scenario.siteName = site.name;
    $scope.scenario.siteIcon = site.type_name;
    $scope.isSecondary = $scope.scenario.common.is_secondary === 1;
    $scope.savedScenario = angular.copy(scenario);

    $scope.data = { scenarioHasChanged: false };

    let strategy = StrategiesFactory.getStrategy(site.type_name);
    $scope.externalInboxURL = strategy.externalInboxURL(site);

    $scope.isCampaignScenario = scenarioFlavor === 'campaign-scenarios';

    $scope.isSaving = false;

    ClicksMetricHelperFactory.maybeInitScenarioMetrics($scope, site, $scope.scenario.common.id);
  }

}
